/* eslint-disable tailwindcss/no-arbitrary-value */
import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { ProductDetails as ProductDetailsOG } from '../ProductDetails.component';
import { PIPSharebelt } from './PIPSharebelt';

export const PIPProductDetails = ({
  itemId, configId = undefined, hideRatingsIfHDPPSku = false, qaIndex = undefined,
  ratingIndex = undefined, showShareBeltPrint = false, showShareBeltShareButton = false, showShareBeltLabels = false,
  hideAddToList = false, showFavoritesCount = false, noPipSpacing = false, ...props
}) => {
  const qaSelector = '#product-section-qa';
  const setExpandedRef = useRef(null);
  const ratingsRef = useRef(null);
  const qaRef = useRef(null);
  const handleScrolling = (element) => {
    if (typeof window === 'undefined' || !element) {
      return;
    }

    const STICKY_HEADER_HEIGHT = 125;
    const top = element.getBoundingClientRect().top + window.scrollY - STICKY_HEADER_HEIGHT;
    window.scroll({
      top,
      behavior: 'smooth'
    });
  };

  const onClick = useCallback((evt, target, index) => {
    if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
      window.LIFE_CYCLE_EVENT_BUS.trigger('product-details.ratings-click');
    }

    let element = ratingsRef.current;
    let targetIndex = ratingIndex || index;
    if (target === qaSelector) {
      element = qaRef.current;
      targetIndex = qaIndex;
    }
    if (setExpandedRef.current) {
      setExpandedRef.current(targetIndex)(evt, true);
    }
    handleScrolling(element);
  }, [ratingIndex, qaIndex]);

  useEffect(() => {
    if (typeof window !== 'undefined' && window?.LIFE_CYCLE_EVENT_BUS?.lifeCycle) {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('accordion.mount', ({ output }) => {
        const { wrapperIds, setExpanded } = output;
        setExpandedRef.current = setExpanded;
        ratingsRef.current = document.querySelector('#' + wrapperIds[ratingIndex]);
        qaRef.current = document.querySelector('#' + wrapperIds[qaIndex]);
      });
    }
  }, []);

  return (
    <ProductDetailsOG itemId={itemId} configId={configId}>
      <ProductDetailsOG.Badge itemId={itemId} configId={configId} noPipSpacing={noPipSpacing} />
      <ProductDetailsOG.BrandCollection
        showBrandHyperLink
        hideRatingsIfHDPPSku={hideRatingsIfHDPPSku}
        noPipSpacing={noPipSpacing}
      />
      <div className="sui-w-[85%]">
        <ProductDetailsOG.Title />
      </div>
      {/* change logic to show when new media gallery gets apply */}
      <PIPSharebelt
        itemId={itemId}
        showShareBeltPrint={showShareBeltPrint}
        showShareBeltShareButton={showShareBeltShareButton}
        hideAddToList={hideAddToList}
        showShareBeltLabels={showShareBeltLabels}
        showFavoritesCount={showFavoritesCount}
      />
      <ProductDetailsOG.Ratings
        showBadge
        offsetselector="#sticky-nav"
        qaselector={qaSelector}
        onClick={onClick}
        useHeaderIndex={!!(ratingIndex || qaIndex)}
        hideRatingsIfHDPPSku={hideRatingsIfHDPPSku}
      />
    </ProductDetailsOG>
  );
};

PIPProductDetails.propTypes = {
  itemId: PropTypes.string.isRequired,
  hideRatingsIfHDPPSku: PropTypes.bool,
  configId: PropTypes.string,
  ratingIndex: PropTypes.number,
  qaIndex: PropTypes.number,
  showShareBeltPrint: PropTypes.bool,
  showShareBeltShareButton: PropTypes.bool,
  hideAddToList: PropTypes.bool,
  showShareBeltLabels: PropTypes.bool,
  showFavoritesCount: PropTypes.bool,
  noPipSpacing: PropTypes.bool,
};

PIPProductDetails.displayName = 'PIPProductDetails';

PIPProductDetails.dataModel = extend({}, ProductDetailsOG);
